/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import LogicContext from "../../Context/LogicContext";
import { SetModuleList, GetModuleList } from "../../store/moduleListAtom";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { moduleListService } from "../../services/module-list.service";




const ModuleListPage = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const url = pathname.split("/");
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];
    const { showToast } = useContext(LogicContext);

    const setModuleListData = SetModuleList();
    const getModuleListData = GetModuleList();
    const [tableData, setTableData] = useState([]);
    const [itemSelected, setItemSelected] = useState([]);
    const [searchText, setSearchText] = useState("");



    // Memoized columns
    const columns = useMemo(
        () => [
            {
                title: "Module Id",
                key: "module_id",
                dataIndex: "module_id",
                className: "text-blue-600 font-medium",
                sorter: (a, b) => (a?.module_id ?? "").localeCompare(b?.module_id ?? ""),
            },
            {
                title: "Module Name",
                dataIndex: "module_name",
                sorter: (a, b) => (a?.module_name ?? "").localeCompare(b?.module_name ?? ""),
            },
            {
                title: "Module Description",
                dataIndex: "module_description",
                sorter: (a, b) => (a?.module_description ?? "").localeCompare(b?.module_description ?? ""),
            },
            {
                title: "Module Status",
                dataIndex: "status_name",
                sorter: (a, b) => (a?.status_name ?? "").localeCompare(b?.status_name ?? ""),
            },



        ],
        []
    );

    // Set table data from global state
    useEffect(() => {
        if (getModuleListData?.module_list?.length > 0) {
            setTableData(getModuleListData?.module_list);
        } else {
            getStockListFromAPI();
        }
        return () => {
        };
    }, []);

    // Handle session-based reload
    useEffect(() => {
        if (sessionStorage.getItem("reloadPage") === "true") {
            sessionStorage.removeItem("reloadPage");
            getStockListFromAPI();
        }
    }, []);

    // Fetch stock list
    const getStockListFromAPI = useCallback(async () => {
        try {
            const response = await moduleListService.getModuleList();
            console.log('modules ', response.data)
            if (response?.data !== undefined) {
                setModuleListData(response.data);
                setTableData(response.data?.module_list || []);

            }
        } catch (err) {
            console.error(err);
        }
    }, [setModuleListData]);




    const selectedTableItems = useCallback((itemList) => {
        setItemSelected(itemList);
    }, []);



    const handleRowClick = useCallback(
        (data) => {
            const id = data["module_id"];
            navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
        },
        [currModuleId, currModuleName, currUserMenu, navigate]
    );

    const onClearInput = () => {
        setSearchText("");
        setTableData(getModuleListData?.module_list || []);
    };

    const handleSearch = (text) => {
        setSearchText(text);
        if (text.trim() === "") {
            setTableData(getModuleListData?.module_list || []);
            return;
        }
        const searchTerm = text.toLowerCase();
        const filtered = (getModuleListData?.module_list || []).filter((item) =>
            Object.values(item).some((value) => value?.toString().toLowerCase().includes(searchTerm))
        );
        setTableData(filtered);
    };


    const addNew = useCallback(() => {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }, [navigate, currModuleId, currModuleName, currUserMenu]);



    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 space-y-4 md:space-y-0">
                <h2 className="text-2xl font-bold text-gray-800">Module List Page</h2>
                <div className="flex items-center space-x-4">
                    {/* Refresh Button */}
                    <button
                        onClick={getStockListFromAPI}
                        className="p-2 rounded-full  shadow-md hover:bg-gray-100 transition-colors"
                        title="Refresh"
                    >
                        {/* <IoMdRefresh className="h-5 w-5 text-gray-600" /> */}
                        <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />



                    </button>
                    {/* Add New Button */}
                    <button
                        onClick={addNew}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition-colors flex items-center space-x-2"
                    >
                        {/* <FaPlus className="h-4 w-4" /> */}
                        <span className="text-white" >Add New</span>
                    </button>
                </div>
            </div>

            {/* Search Input */}
            <div className="mb-6">
                <input
                    type="text"
                    placeholder="Search in table..."
                    value={searchText}
                    onKeyDown={(e) => {
                        if (e.key === "Backspace" && searchText === "") {
                            onClearInput();
                        }
                    }}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
            </div>

            {/* Table Section */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <GeneralCustomTable
                    tableHeadList={columns}
                    tableDataList={tableData}
                    allowCheckBox={true}
                    setSelectedRows={selectedTableItems}
                    rowKey={(record) => record.user_id} // Updated to use item_id as key
                    handleRowClick={handleRowClick}
                />
            </div>
        </div>
    );
};

export default React.memo(ModuleListPage);